import React from "react";

/**
 * Star toggle for the watchlist. Rendered inside table rows so it must
 * stop propagation to avoid opening the detail modal.
 */
export default function WatchlistToggle({ starred, onToggle, symbol }) {
  return (
    <button
      type="button"
      className={`watch-toggle ${starred ? "starred" : ""}`}
      aria-pressed={starred}
      aria-label={starred ? `Remove ${symbol} from watchlist` : `Add ${symbol} to watchlist`}
      title={starred ? "Remove from watchlist" : "Add to watchlist"}
      onClick={(e) => {
        e.stopPropagation();
        onToggle();
      }}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") e.stopPropagation();
      }}
    >
      <svg viewBox="0 0 24 24" width="14" height="14" aria-hidden="true" focusable="false">
        <path
          d="M12 2.6l2.9 5.9 6.5.9-4.7 4.6 1.1 6.4L12 17.4l-5.8 3-1.1-6.4L.4 9.4l6.5-.9z"
          className="star-path"
        />
      </svg>
    </button>
  );
}
